import React, { useContext } from 'react';
import { CaseSummaryConstants } from 'src/constants/ProjectConstants';
import styled from 'styled-components';
import { TranslationContext } from 'src/state/providers/TranslationProvider';

export interface IElementHeading {
  header: string;
  onEditClick: Function;
}

const ElementHeadingContainer = styled.div`
  background: ${({ theme }) => theme.colors.Seattle};
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.Azure};
`;

const HeaderContainer = styled.div`
  color: ${({ theme }) => theme.colors.Nordic};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize.s};
  padding: 0.5rem 0rem 0.5rem 0rem;
  flex: 1;
`;

const EditIconContainer = styled.div`
  color: ${({ theme }) => theme.colors.Nordic};
  :hover {
    cursor: pointer;
  }
`;

const Edit = styled.div`
  color: ${({ theme }) => theme.colors.White};
  background: ${({ theme }) => theme.colors.Eastern};
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding: 0rem 0.2rem 0rem 0.2rem;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const ElementHeading: React.FC<IElementHeading> = ({ header, onEditClick }) => {
  const { commonBundle } = useContext(TranslationContext);

  return (
    <ElementHeadingContainer data-testid="ElementHeadingContainer">
      <HeaderContainer>{header?.toUpperCase()}</HeaderContainer>
      <EditIconContainer>
        <Edit onClick={() => onEditClick(true)}>
          {commonBundle.getMessage(CaseSummaryConstants.EDIT_BUTTON_TEXT)}
        </Edit>
      </EditIconContainer>
    </ElementHeadingContainer>
  );
};

export { ElementHeading };
